import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

export const ErrorFallback = ({ resetErrorBoundary }) => {
    const navigate = useNavigate();

    const handleTryAgain = () => {
        // Option 1: Navigate to some route (say '/', or login, etc.)
        navigate('/');
        // Option 2: Or reset the error boundary to retry the same component
        // You can call resetErrorBoundary() if you want to re-render the same part.
        resetErrorBoundary();
    };

    return (
        <Stack className="page-not-found">
            <Typography variant="h5">Oops! Something went wrong.</Typography>
            <Button variant="contained" startIcon={<ArrowBack />} onClick={handleTryAgain}>
                Back to home page
            </Button>
        </Stack>
    );
};
